import { render } from "./Background.vue?vue&type=template&id=38e97844"
import script from "./Background.vue?vue&type=script&lang=ts"
export * from "./Background.vue?vue&type=script&lang=ts"
script.render = render

export default script